<section class="integrations-section">
  <h2 class="integrations-section__title">My integrations</h2>
  <div
    class="integrations-list"
    rvSpinner="integrations-user-section"
    [rvShowSpinner]="loading()"
    [attr.aria-busy]="initialLoading() || loading() ? 'true' : null"
  >
    @if (initialLoading()) {
      <div
        class="integration-connected-row-skeleton"
        role="status"
        aria-label="Loading integrations"
      >
        @for (row of [1, 2, 3]; track row) {
          <div
            class="integration-connected-row-skeleton__row"
            aria-hidden="true"
          >
            <div class="integration-connected-row-skeleton__info">
              <rv-skeleton
                class="integration-connected-row-skeleton__logo"
                [height]="52"
              />
              <div class="integration-connected-row-skeleton__text">
                <rv-skeleton
                  class="integration-connected-row-skeleton__name"
                  [height]="20"
                />
                <rv-skeleton
                  class="integration-connected-row-skeleton__username"
                  [height]="20"
                />
              </div>
            </div>
            <div class="integration-connected-row-skeleton__status">
              <rv-skeleton
                class="integration-connected-row-skeleton__status-label"
                [height]="20"
              />
            </div>
            <div class="integration-connected-row-skeleton__actions">
              <div class="integration-connected-row-skeleton__actions-desktop">
                <rv-skeleton
                  class="integration-connected-row-skeleton__button"
                  [height]="40"
                />
              </div>
              <div class="integration-connected-row-skeleton__actions-mobile">
                <rv-skeleton
                  class="integration-connected-row-skeleton__icon-button"
                  [height]="32"
                />
              </div>
            </div>
          </div>
        }
      </div>
    } @else if (integrations().length) {
      @for (
        integration of integrations();
        track integration.id + ':' + (integration.account ?? '')
      ) {
        <integration-connected-row
          [integration]="integration"
          scope="user"
          [hideManage]="true"
          (reconnect)="onReconnect($event)"
          (disconnect)="onDisconnect($event)"
        ></integration-connected-row>
      }
    } @else {
      <div class="integrations-empty">
        <p class="integrations-empty__title">
          You haven't connected any integrations yet
        </p>
        <p class="integrations-empty__subtitle">
          Once you link an integration to a presentation component, it will
          appear here for easy management.
        </p>
      </div>
    }
  </div>
</section>
